<template>
  <div>
    <a-form-model ref="paymentDetailsForm" :model="company" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col>
          <a-form-model-item label="Card number">
            <setup-payment
              :clientSecret="company.payment.clientSecret"
              :publishableToken="publishableToken"
              :triggerSetupPayment="triggerSetupPayment"
              :cardHolderName="company.payment.cardHolderName"
              :events="events"
              @paymentAdded="paymentSetupSuccess"
              @validationStarted="onValidationStarted"
              @validationEnded="onValidationEnded"
            ></setup-payment>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="Card holder name" prop="payment.cardHolderName">
            <a-input id="cardholder-name" placeholder="Card Holder Name" v-model="company.payment.cardHolderName" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Billing address line 1" prop="payment.address.addressLine1">
            <a-input placeholder="Address Line 1" v-model="company.payment.address.addressLine1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Billing address line 2" prop="payment.address.addressLine2">
            <a-input placeholder="Address Line 2" v-model="company.payment.address.addressLine2" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Post code" prop="payment.address.postcode">
            <a-input placeholder="Postcode" v-model="company.payment.address.postcode" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Country/Region" prop="payment.address.countryId">
            <a-select v-model="company.payment.address.countryId" style="width: 100%">
              <a-select-option v-for="country in lookupState.countries" :key="country.id" :value="country.id">
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row
        ><p>{{ `* ${messages.paymentDetails.paymentDisclaimer}` }}</p></a-row
      >
      <a-row
        ><p>{{ `* ${messages.paymentDetails.bankRedirectionMessage}` }}</p></a-row
      >

      <a-row>
        <a-form-model-item class="step-item">
          <a-checkbox-group v-model="newsChecked">
            <a-checkbox :value="true" name="newsChecked"> Recieve news and promotions from GLS</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
      </a-row>
      <a-row>
        <a-form-model-item class="step-item">
          <a-checkbox-group v-model="termsChecked">
            <a-checkbox :value="true" name="termsChecked">
              I have read and agree to the <a href="https://goodlawsoftware.co.uk/terms-and-conditions" target="_blank">GLS terms and conditions</a
              >, <a href="https://goodlawsoftware.co.uk/user-license-agreement" target="_blank">user license agreement</a> and
              <a href="http://goodlawsoftware.co.uk/privacy-policy" target="_blank">privacy policy</a></a-checkbox
            >
          </a-checkbox-group>
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </div>
</template>
<script>
import SetupPayment from '../SetupPayment.vue';
import messages from '../../../assets/Json/messages.json';
import { lookupState, lookupMutations } from '../../../Store/store.js';

export default {
  mounted() {
    this.lookupMutations.getCountries();
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    validate: Boolean,
    publishableToken: String,
    events: Object,
  },
  data() {
    return {
      rules: {
        'payment.cardHolderName': [
          { required: true, message: 'Please input the card holder name', trigger: 'blur' },
          { pattern: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/, message: 'Please enter a valid card holder name', trigger: 'blur' },
        ],
        'payment.address.addressLine1': [{ required: true, message: 'Please input address line 1', trigger: 'blur' }],
        'payment.address.addressLine2': [{ required: true, message: 'Please input address line 2', trigger: 'blur' }],
        'payment.address.postcode': [{ required: true, message: 'Please input post code', trigger: 'blur' }],
        'payment.address.countryId': [{ required: true, message: 'Please select a country', trigger: 'blur' }],
        termsChecked: [
          {
            type: 'array',
            required: true,
            validator: (rule, value, callback) => {
              if (this.termsChecked[0]) {
                callback();
              } else {
                callback('Please input a valid name');
              }
            },
            message: 'Please make sure to check GLS terms and conditions, user license agreement and privacy policy!',
            trigger: 'change',
          },
        ],
      },
      countries: [],
      messages: messages,
      lookupState: lookupState,
      lookupMutations: lookupMutations,
      termsChecked: [],
      newsChecked: [],
      triggerSetupPayment: false,
    };
  },
  methods: {
    async paymentSetupSuccess(event) {
      this.$emit(this.events.paymentAdded, event);
    },
    onValidationStarted() {
      this.$emit(this.events.validationStarted);
    },
    onValidationEnded() {
      this.$emit(this.events.validationEnded);
    },
  },
  watch: {
    validate(val) {
      if (val) {
        this.$refs.paymentDetailsForm.validate((isValid) => {
          this.triggerSetupPayment = isValid && this.termsChecked[0];
        });
      } else {
        this.triggerSetupPayment = false;
      }
    },
    termsChecked: {
      handler: function () {
        this.$emit(this.events.disableNext, !this.termsChecked[0]);
      },
      deep: true,
    },
  },
  components: { SetupPayment },
};
</script>

<style>
</style>
